// One source of truth for the exact promise shown at collection and stored as
// consent evidence. Client forms render these strings verbatim; the server RPC
// persists the same value with the list row and consent timestamp.
export const SUBSCRIPTION_LISTS = {
  newsletter: {
    consent:
      "The MicroPlastics email has no fixed send date, is usually sent no more than monthly, and covers new scores, corrections, and evidence changes. We do not sell your address or share it for another company's marketing; our email and database providers process it for us. Unsubscribe anytime.",
  },
  android_waitlist: {
    consent:
      "One email when the Android app launches. We do not sell your address or share it for another company's marketing; our email and database providers process it for us. Unsubscribe anytime.",
  },
  detox_challenge: {
    consent:
      "One email if a guided 7-day MicroPlastics challenge becomes available. We do not sell your address or share it for another company's marketing; our email and database providers process it for us. Unsubscribe anytime.",
  },
} as const

// The public subscribe endpoint deliberately gives the same acknowledgement
// for a new address, an active duplicate, and a suppressed address. A form
// submission cannot prove ownership, so it must never reverse or claim to
// reverse an earlier unsubscribe.
//
// The unsubscribe clause must stay conditional. The earlier wording stated
// "A prior unsubscribe remains in place" as fact, and because every submitter
// sees this text, brand-new subscribers read it as being told they had
// unsubscribed before and emailed in asking to be added.
//
// The heading thanks them for signing up rather than saying "you're on the
// list", because that is true for all three cases above.
export const SUBSCRIPTION_REQUEST_HEADING = 'Thanks for signing up'

export const SUBSCRIPTION_PRIOR_UNSUBSCRIBE_NOTE =
  'Unsubscribed from this list before? That choice stays in place until you contact us to rejoin.'

// Single-string form for surfaces that show one line of text.
export const SUBSCRIPTION_REQUEST_ACKNOWLEDGEMENT = `${SUBSCRIPTION_REQUEST_HEADING}. You don't need to confirm anything. ${SUBSCRIPTION_PRIOR_UNSUBSCRIBE_NOTE}`

export type SubscriptionListName = keyof typeof SUBSCRIPTION_LISTS
